// import { canUseDOM } from 'exenv';

export function micYearPageLoading(resp = {}, store = {}) {
  return {
    type: 'MIC_YEAR_PAGE_LOADING',
    micYearPage: resp,
    store
  };
}

export function micYearPageLoaded(resp = {}, store = {}) {
  return {
    type: 'MIC_YEAR_PAGE_LOADED',
    micYearPage: resp,
    store
  };
}

export function micYearPageLoadError(error, store = {}) {
  return {
    type: 'MIC_YEAR_PAGE_ERROR',
    micYearPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
